import { FormControl, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent } from '@mui/material';
import { ReactNode, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { styled } from '@mui/material/styles';

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  '& .MuiSelect-select': {
    fontSize: '16px',

    [theme.breakpoints.down(1520)]: {
      fontSize: '14px',
    },
  },
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: '16px',

  [theme.breakpoints.down(1520)]: {
    fontSize: '14px',
  },
}));

interface IOption {
  value: any;
  label: ReactNode;
}

interface IProps {
  label: ReactNode;
  options: IOption[];
  value: any;
  setValue: (value: any) => void;
  updateUrl?: boolean;
  urlParamName?: string;
}

export const SelectDropdown = ({ label, options, value, setValue, updateUrl = false, urlParamName }: IProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const handleChange = (event: SelectChangeEvent<string>) => {
    const newValue = event.target.value;
    setValue(newValue);
    // Update URL if requested
    if (updateUrl && urlParamName) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set(urlParamName, newValue);

      // Remove service-provider parameter when updating URL
      if (newParams.has('service-provider')) {
        newParams.delete('service-provider');
      }

      setSearchParams(newParams);
    }
  };

  const ValueRender = useCallback(
    (value: string) => {
      const selected = options?.find((option) => option.value === value)?.label;
      return <span className='capitalize'>{selected}</span>;
    },
    [options]
  );

  return (
    <StyledFormControl size='small'>
      <InputLabel>{label}</InputLabel>
      <Select onChange={handleChange} value={value} input={<OutlinedInput label={label} />} renderValue={ValueRender}>
        {options?.map((option) => (
          <StyledMenuItem key={option.value} value={option.value}>
            {option.label}
          </StyledMenuItem>
        ))}
      </Select>
    </StyledFormControl>
  );
};
